import { useEffect, useState } from "react";
import axios from "axios";
import { Logo } from "@/components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/leads`)
      .then((r) => setLeads(r.data))
      .catch(() => setError("Could not load leads."))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#F5F5F7] px-6 sm:px-12 py-10" data-testid="admin-page">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between">
          <Logo />
          <a href="/" className="text-xs text-[#808080] hover:text-[#3A3A3C] transition-colors" data-testid="admin-back-link">
            ← Back to site
          </a>
        </div>
        <h1 className="font-display font-bold tracking-tighter text-4xl text-[#3A3A3C] mt-12" data-testid="admin-title">
          Enterprise Pilot Leads
        </h1>
        <p className="text-sm text-[#808080] mt-2">{leads.length} request{leads.length === 1 ? "" : "s"}</p>

        <div className="mt-8 rounded-3xl bg-white border border-black/5 shadow-sm overflow-hidden">
          {loading ? (
            <p className="p-10 text-sm text-[#808080]" data-testid="admin-loading">Loading…</p>
          ) : error ? (
            <p className="p-10 text-sm text-red-500" data-testid="admin-error">{error}</p>
          ) : leads.length === 0 ? (
            <p className="p-10 text-sm text-[#808080]" data-testid="admin-empty">No leads yet — submissions from the pilot form appear here.</p>
          ) : (
            <table className="w-full text-sm" data-testid="admin-leads-table">
              <thead>
                <tr className="border-b border-black/5 text-left">
                  <th className="px-6 py-4 font-mono2 text-[10px] uppercase tracking-[0.2em] text-[#808080]">Work Email</th>
                  <th className="px-6 py-4 font-mono2 text-[10px] uppercase tracking-[0.2em] text-[#808080]">Facility</th>
                  <th className="px-6 py-4 font-mono2 text-[10px] uppercase tracking-[0.2em] text-[#808080]">Received</th>
                </tr>
              </thead>
              <tbody>
                {leads.map((l) => (
                  <tr key={l.id} className="border-b border-black/5 last:border-0 hover:bg-[#FAF9F6] transition-colors" data-testid={`admin-lead-row-${l.id}`}>
                    <td className="px-6 py-4 text-[#3A3A3C] font-medium">{l.email}</td>
                    <td className="px-6 py-4 text-[#474747] capitalize">{l.facility_type || "—"}</td>
                    <td className="px-6 py-4 text-[#808080]">{new Date(l.created_at).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
